import { render, staticRenderFns } from "./BtnScrollTop.vue?vue&type=template&id=2976914a&"
import script from "./BtnScrollTop.vue?vue&type=script&lang=js&"
export * from "./BtnScrollTop.vue?vue&type=script&lang=js&"
import style0 from "./BtnScrollTop.vue?vue&type=style&index=0&id=2976914a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports